import CheckboxWithLabel from "../checkboxWithLabel/CheckboxWithLabel"
import PropTypes from "prop-types";

function CheckboxFieldsList({fields, name, onChange, deletable, onDelete, locked}){
    return (
        <section className="fieldsList"> 
            {name && <p className="sectionTitle">{name}</p>}
            {fields.map(field => (
                <CheckboxWithLabel 
                    key={Math.random()} 
                    name={field.value} 
                    value={field.checked}
                    onChange={(value) => onChange(field.value, value)}
                    deletable={deletable}
                    onDelete={onDelete}
                    locked={locked}
                />
            ))}
        </section>
    )
}

CheckboxFieldsList.propTypes = {
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            checked: PropTypes.bool.isRequired
        })
    ).isRequired,
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    deletable: PropTypes.bool,
    onDelete: PropTypes.func,
    locked: PropTypes.bool
}

export default CheckboxFieldsList;